import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'tg-modal';

import { gettext } from '../utils/text';
import api from '../utils/api';
import Loading from './Loading';
import Comment from './Comment';

const commentTypes = {
    FOR_ITEM: 1,
    GUESTMENTOR: 2,
    PUBLIC: 3,
};

/**
 * Component for comments display for news, media, projects
 *
 * Not supposed to deal with any application (funding, mentor) pseudo-comments
 */
class Comments extends React.Component {
    static propTypes = {
        modelName: PropTypes.string,
        pk: PropTypes.number,
        commentType: PropTypes.number,
        title: PropTypes.string,
        contentAndImageLinks: PropTypes.bool,
    };

    static defaultProps = {
        modelName: null,
        pk: null,
        commentType: commentTypes.FOR_ITEM,
        title: gettext('Comments'),
        contentAndImageLinks: false,
    };

    static commentTypes = commentTypes;

    constructor(props) {
        super(props);
        this.state = {
            comments: null,
            deletionModalIsOpen: false,
            currentComment: null, // to render deletion modal with the comment's text
        };
    }

    componentDidMount() {
        if (this.state.comments === null) {
            this.fetchComments();
        }
    }

    deleteComment({ id }) {
        api.commentDetail
            .del({ pk: id })
            .then(() => {
                const { comments } = this.state;
                this.setState({
                    comments: comments.filter((c) => c.id !== id),
                });
            })
            .catch(() => {
                // do something?
            });
        this.toggleDeletionModal();
    }

    fetchComments() {
        const { commentType } = this.props;
        let apiCall;
        if (commentType === commentTypes.FOR_ITEM) {
            apiCall = api.commentsForItem.fetch({ pk: this.props.pk, model: this.props.modelName });
        } else if (commentType === commentTypes.PUBLIC) {
            apiCall = api.commentsPublic.fetch();
        } else if (commentType === commentTypes.GUESTMENTOR) {
            apiCall = api.commentsGuestMentor.fetch();
        }
        apiCall
            .then((response) => {
                this.setState({
                    comments: response,
                });
            })
            .catch(() => {
                this.setState({
                    comments: 'ERROR',
                });
            });
    }

    toggleDeletionModal(comment) {
        this.setState({
            deletionModalIsOpen: !!comment,
            currentComment: comment,
        });
    }

    renderComment(comment) {
        return (
            <Comment
                key={comment.id}
                comment={comment}
                onDelete={() => this.toggleDeletionModal(comment)}
                contentAndImageLinks={this.props.contentAndImageLinks}
            />
        );
    }

    renderDeletionModal() {
        if (DJ_CONST.user === null) {
            // skip it entirely if not auth'd
            return null;
        }
        const { currentComment } = this.state;
        const commentText = currentComment ? currentComment.comment : '';
        return (
            <Modal
                isOpen={this.state.deletionModalIsOpen}
                onCancel={this.toggleDeletionModal}
                isBasic
                isStatic
                dialogClassName="comment-deletion-modal__wrapper"
            >
                <div className="comment-deletion-modal">
                    <h3>Delete comment</h3>
                    <p>{commentText}</p>
                    <div className="__buttons">
                        <button onClick={() => this.deleteComment(currentComment)}>Delete</button>
                        <button onClick={() => this.toggleDeletionModal()}>Cancel</button>
                    </div>
                </div>
            </Modal>
        );
    }

    render() {
        const { comments } = this.state;
        let title;
        let total;
        let renderedComments;
        if (comments === null) {
            title = gettext('Loading comments...');
            renderedComments = <Loading />;
        } else if (comments === 'ERROR') {
            renderedComments = gettext('There was an error loading comments.');
        } else if (comments.length > 0) {
            title = this.props.title;
            if (this.props.commentType === commentTypes.FOR_ITEM) {
                total = <div className="number-of-comments">{comments.length}</div>;
            }
            renderedComments = comments.map((comment) => this.renderComment(comment));
        } else {
            title = gettext('Be the first one to comment');
        }
        return (
            <div className="comments__list">
                {this.renderDeletionModal()}
                <div className="comments__list__heading">
                    {total}
                    <h3>{title}</h3>
                </div>
                {renderedComments}
            </div>
        );
    }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/components/Comments.js